/* eslint-disable */
// Custom GraphQL operations for SCHEDULEDEMAILS

export const listSCHEDULEDEMAILS = /* GraphQL */ `
  query ListSCHEDULEDEMAILS(
    $filter: ModelSCHEDULEDEMAILSFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSCHEDULEDEMAILS(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        scheduledDate
        clientID
        vendorID
        certificateID
        recipients
        action
        vendorName
        clientName
        uploadLink
        subject
        content
        greeting
        signature
        status
        emailNotificationID
        certificateStatus
        vendorStatus
        expirationDate
        reminderType
        pausedAt
        pausedBy
        cancelledAt
        cancelledBy
        sentAt
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const getSCHEDULEDEMAILS = /* GraphQL */ `
  query GetSCHEDULEDEMAILS($id: ID!) {
    getSCHEDULEDEMAILS(id: $id) {
      id
      scheduledDate
      clientID
      vendorID
      certificateID
      recipients
      action
      vendorName
      clientName
      uploadLink
      subject
      content
      greeting
      signature
      status
      emailNotificationID
      certificateStatus
      vendorStatus
      expirationDate
      reminderType
      pausedAt
      pausedBy
      cancelledAt
      cancelledBy
      sentAt
      createdAt
      updatedAt
    }
  }
`;

export const createSCHEDULEDEMAILS = /* GraphQL */ `
  mutation CreateSCHEDULEDEMAILS(
    $input: CreateSCHEDULEDEMAILSInput!
    $condition: ModelSCHEDULEDEMAILSConditionInput
  ) {
    createSCHEDULEDEMAILS(input: $input, condition: $condition) {
      id
      scheduledDate
      clientID
      vendorID
      certificateID
      recipients
      action
      vendorName
      clientName
      uploadLink
      subject
      content
      greeting
      signature
      status
      emailNotificationID
      certificateStatus
      vendorStatus
      expirationDate
      reminderType
      pausedAt
      pausedBy
      cancelledAt
      cancelledBy
      sentAt
      createdAt
      updatedAt
    }
  }
`;

export const updateSCHEDULEDEMAILS = /* GraphQL */ `
  mutation UpdateSCHEDULEDEMAILS(
    $input: UpdateSCHEDULEDEMAILSInput!
    $condition: ModelSCHEDULEDEMAILSConditionInput
  ) {
    updateSCHEDULEDEMAILS(input: $input, condition: $condition) {
      id
      scheduledDate
      clientID
      vendorID
      certificateID
      recipients
      action
      vendorName
      clientName
      uploadLink
      subject
      content
      greeting
      signature
      status
      emailNotificationID
      certificateStatus
      vendorStatus
      expirationDate
      reminderType
      pausedAt
      pausedBy
      cancelledAt
      cancelledBy
      sentAt
      createdAt
      updatedAt
    }
  }
`;

export const deleteSCHEDULEDEMAILS = /* GraphQL */ `
  mutation DeleteSCHEDULEDEMAILS(
    $input: DeleteSCHEDULEDEMAILSInput!
    $condition: ModelSCHEDULEDEMAILSConditionInput
  ) {
    deleteSCHEDULEDEMAILS(input: $input, condition: $condition) {
      id
    }
  }
`;

// Query by scheduled date
export const scheduledEmailsByDate = /* GraphQL */ `
  query ScheduledEmailsByDate(
    $scheduledDate: AWSDateTime!
    $status: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSCHEDULEDEMAILSFilterInput
    $limit: Int
    $nextToken: String
  ) {
    scheduledEmailsByDate(
      scheduledDate: $scheduledDate
      status: $status
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        scheduledDate
        clientID
        vendorID
        certificateID
        recipients
        action
        vendorName
        clientName
        uploadLink
        subject
        content
        greeting
        signature
        status
        emailNotificationID
        certificateStatus
        vendorStatus
        expirationDate
        reminderType
        pausedAt
        pausedBy
        cancelledAt
        cancelledBy
        sentAt
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

// Query by client
export const scheduledEmailsByClient = /* GraphQL */ `
  query ScheduledEmailsByClient(
    $clientID: ID!
    $scheduledDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSCHEDULEDEMAILSFilterInput
    $limit: Int
    $nextToken: String
  ) {
    scheduledEmailsByClient(
      clientID: $clientID
      scheduledDate: $scheduledDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        scheduledDate
        clientID
        vendorID
        certificateID
        recipients
        action
        vendorName
        clientName
        uploadLink
        subject
        content
        greeting
        signature
        status
        emailNotificationID
        certificateStatus
        vendorStatus
        expirationDate
        reminderType
        pausedAt
        pausedBy
        cancelledAt
        cancelledBy
        sentAt
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

// Query by vendor
export const scheduledEmailsByVendor = /* GraphQL */ `
  query ScheduledEmailsByVendor(
    $vendorID: ID!
    $scheduledDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSCHEDULEDEMAILSFilterInput
    $limit: Int
    $nextToken: String
  ) {
    scheduledEmailsByVendor(
      vendorID: $vendorID
      scheduledDate: $scheduledDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        scheduledDate
        clientID
        vendorID
        certificateID
        recipients
        action
        vendorName
        clientName
        uploadLink
        subject
        content
        greeting
        signature
        status
        emailNotificationID
        certificateStatus
        vendorStatus
        expirationDate
        reminderType
        pausedAt
        pausedBy
        cancelledAt
        cancelledBy
        sentAt
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;